/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ sample: NonNullable<unknown> }} Measure_Reliability_Caption_SampleInputs */

const en_measure_reliability_caption_sample = /** @type {(inputs: Measure_Reliability_Caption_SampleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`of calls succeeded (${i?.sample})`)
};

const zh_hans1_measure_reliability_caption_sample = /** @type {(inputs: Measure_Reliability_Caption_SampleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`的调用成功（${i?.sample}）`)
};

const pt_br2_measure_reliability_caption_sample = /** @type {(inputs: Measure_Reliability_Caption_SampleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`das chamadas tiveram sucesso (${i?.sample})`)
};

const es_measure_reliability_caption_sample = /** @type {(inputs: Measure_Reliability_Caption_SampleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`de las llamadas tuvieron éxito (${i?.sample})`)
};

const fr_measure_reliability_caption_sample = /** @type {(inputs: Measure_Reliability_Caption_SampleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`des appels ont réussi (${i?.sample})`)
};

const de_measure_reliability_caption_sample = /** @type {(inputs: Measure_Reliability_Caption_SampleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`der Aufrufe erfolgreich (${i?.sample})`)
};

const ru_measure_reliability_caption_sample = /** @type {(inputs: Measure_Reliability_Caption_SampleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`вызовов выполнено успешно (${i?.sample})`)
};

const it_measure_reliability_caption_sample = /** @type {(inputs: Measure_Reliability_Caption_SampleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`delle chiamate riuscite (${i?.sample})`)
};

/**
* | output |
* | --- |
* | "of calls succeeded ({sample})" |
*
* @param {Measure_Reliability_Caption_SampleInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const measure_reliability_caption_sample = /** @type {((inputs: Measure_Reliability_Caption_SampleInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Measure_Reliability_Caption_SampleInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_measure_reliability_caption_sample(inputs)
	if (locale === "pt-BR") return pt_br2_measure_reliability_caption_sample(inputs)
	if (locale === "es") return es_measure_reliability_caption_sample(inputs)
	if (locale === "fr") return fr_measure_reliability_caption_sample(inputs)
	if (locale === "de") return de_measure_reliability_caption_sample(inputs)
	if (locale === "ru") return ru_measure_reliability_caption_sample(inputs)
	if (locale === "it") return it_measure_reliability_caption_sample(inputs)
	return en_measure_reliability_caption_sample(inputs)
});